import React, { Component } from 'react';

class IconChatScrollBottom extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="49"
                fill="none"
                viewBox="0 0 48 49"
            >
                <circle cx="24" cy="24.5" r="24" fill="#CDDDEC"></circle>
                <g fill="#1D1D1D" clipPath="url(#clip0_4441_52545)">
                    <path d="M21.648 24.87l1.307 1.272a1.526 1.526 0 001.052.555 1.503 1.503 0 001.03-.555l8.327-8.316 2.14-2.14c.075-.068.145-.141.208-.22a1.215 1.215 0 00.231-1.156 1.237 1.237 0 00-.786-.822 1.249 1.249 0 00-1.365.405l-9.611 9.612-.186.185-.115-.093-9.53-9.53-.209-.209a1.26 1.26 0 00-1.156-.254 1.156 1.156 0 00-.822.81 1.26 1.26 0 00.405 1.353l9.08 9.103z"></path>
                    <path d="M35.154 22.198a1.26 1.26 0 00-1.353.393l-9.577 9.589-.22.185-.197-.15-9.519-9.543-.069-.07-.208-.196a1.157 1.157 0 00-1.157-.243 1.156 1.156 0 00-.821.798 1.214 1.214 0 00.382 1.33l8.189 8.19 2.313 2.313c.26.304.63.495 1.03.532a1.517 1.517 0 001.029-.544l10.41-10.41.069-.069.196-.208a1.156 1.156 0 00.232-1.157 1.156 1.156 0 00-.729-.74z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_4441_52545">
                        <path
                            fill="#fff"
                            d="M0 0H24V21.849H0z"
                            transform="translate(12 13.5)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconChatScrollBottom;